import { Typography } from '@mui/material'
import { OrderProps, RequestTrackingByOrderResponse, RequestTrackingByChildrenResponse } from '../../types/tracking'
import { error } from '../../utils/resources'

interface TrackingAlertProps {
    parent: RequestTrackingByOrderResponse,
    children?: RequestTrackingByChildrenResponse
}



const TrackingAlert = ({ parent, children }: TrackingAlertProps) => {
    return (
        <Typography>
            Mensaje de error...
        </Typography>
    )
}

interface TrackingAlertErrorByOrderProps {
    order: OrderProps
}

const TrackingAlertErrorByOrder = ({ order }: TrackingAlertErrorByOrderProps) => {
    
    if (!order.eventoTipoFinalizacionTracking) {
        return null
    }

    const event = error(order.idCategoriaEvento)

    if (!event) {
        return null
    }

    return (
        <Typography variant="caption" color="text.secondary" lineHeight={1}>
           {event}
        </Typography>
    )
}

export default TrackingAlert
export { TrackingAlertErrorByOrder }
